import * as actionTypes from '../actionTypes/notifications';

export default {
  getNotifications: () => ({
    type: actionTypes.GET_NOTIFICATIONS,
    payload: {},
  }),
  addNotifications: (data) => ({
    type: actionTypes.ADD_NOTIFICATIONS,
    payload: {
      ...data,
    },
  }),
  addNewNotification: (data) => ({
    type: actionTypes.ADD_NEW_NOTIFICATION,
    payload: {
      ...data,
    },
  }),
  removeNotification: (index) => ({
    type: actionTypes.REMOVE_NOTIFICATION,
    payload: {
      ...index,
    },
  }),
  expireNotification: (data) => ({
    type: actionTypes.EXPIRE_NOTIFICATION,
    payload: {
      ...data,
    },
  }),
  markAsRead: (index) => ({
    type: actionTypes.MARK_AS_READ,
    payload: {
      ...index,
    },
  }),
  markAllRead: () => ({
    type: actionTypes.MARK_ALL_READ,
    payload: {},
  }),
  markAllSeen: () => ({
    type: actionTypes.MARK_ALL_SEEN,
    payload: {},
  }),
};
